import { useBox } from "@react-three/cannon";
import { useRef } from "react";

//Cannon Physics object for a limited size plane
export function CannonPlane({
  size = [1, 1],
  thickness = 0.01,
  rotation,
  position = [0, 0, 0],
  ref,
}) {
  useBox(
    () => ({
      type: "Static",
      args: [size[0], thickness, size[1] ?? size[0]],
      rotation,
      position,
    }),
    useRef(ref)
  );
}
